import { jsx as _jsx } from "react/jsx-runtime";
import { createSvgIcon, IconDirectionality } from './tools';
export const Warning = createSvgIcon('0 0 24 25', IconDirectionality.All, _jsx("path", { fill: 'currentColor', d: 'M12 2.611c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m1 15h-2v-2h2zm0-4h-2v-6h2z' }));
